/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { renderRoutes, RouteConfig } from 'react-router-config';
import { useHistory, useLocation } from 'react-router-dom';
import {
  getFirstManageSite,
  getNeedManageSites,
  isMultiManageSite,
  isSplitSitePage,
} from '../../lib/multi-site';
import { SiteSwitchTab } from '../component/site-switch-tab';
import { AdminPermCheck } from './components/admin-permission-check';
import { initAllSiteUsers } from './lib/columns';
import { getAllSiteConfigs } from '../../lib/app';

export interface IProps {
  readonly route?: RouteConfig;
}

export const SupportRightSide = (props: IProps) => {
  const location = useLocation();
  const history = useHistory();

  const [site, setSite] = useState<string>();

  useEffect(() => {
    initAllSiteUsers();
    getAllSiteConfigs();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const querySite = params.get('site');
    const currentSite = querySite || site || getFirstManageSite();
    if (!querySite && currentSite !== getFirstManageSite()) {
      params.set('site', currentSite);
      const siteUrlSearch = params.toString();
      history.push(`${location.pathname}?${siteUrlSearch}`);
    }
    setSite(currentSite || undefined);
  }, [location]);

  const showSplitSite = isSplitSitePage();

  return (
    <AdminPermCheck>
      <>
        {showSplitSite && (
          <>
            <SiteSwitchTab activeTab={site} />
            {getNeedManageSites().map((currentSite) => {
              return (
                <div
                  style={{ display: site === currentSite ? 'block' : 'none' }}
                >
                  {renderRoutes(props.route?.routes, { site: currentSite })}
                </div>
              );
            })}
          </>
        )}
        {!showSplitSite && renderRoutes(props.route?.routes)}
      </>
    </AdminPermCheck>
  );
};
